import { service } from '@ember/service';
import type { Snapshot } from '@ember-data/legacy-compat/-private';
import ApplicationAdapter from 'lumen/adapters/application';
import type { BudgetForecastEntry } from 'lumen/models';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';

export default class BudgetForecastEntryAdapter extends ApplicationAdapter {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;

  // @ts-expect-error: Property 'buildURL' in type 'BudgetForecastEntryAdapter' is not assignable to the same property in base type 'ApplicationAdapter'.
  buildURL(
    modelName: string,
    id: string,
    snapshot: Snapshot<unknown>,
    requestType: string,
    query?: Record<string, unknown>,
  ): string {
    // @ts-expect-error: Expected 3 arguments, but got 5.
    const baseUrl = super.buildURL(modelName, id, snapshot, requestType, query);

    const url = new URL(baseUrl, this.host);
    url.searchParams.set(
      'subscription_id',
      this.hotelAndMarketService.hotel.id!,
    );

    return url.toString();
  }

  urlForCreateRecord(
    _modelName: string,
    snapshot: Snapshot<BudgetForecastEntry>,
  ): string {
    if (!snapshot.record) {
      return '';
    }

    return snapshot.record.dataType === 'budget'
      ? '/apigateway/v1/app/budgetforecast/budget/entries/'
      : '/apigateway/v1/app/budgetforecast/forecast/entries/';
  }

  urlForDeleteRecord(id: string | number): string {
    return `/apigateway/v1/app/budgetforecast/entries/${id}`;
  }

  urlForFindRecord(id: string | number): string {
    return `/apigateway/v1/app/budgetforecast/entries/${id}`;
  }

  urlForUpdateRecord(id: string | number): string {
    return `/apigateway/v1/app/budgetforecast/entries/${id}`;
  }
}
